module.exports = __webpack_public_path__ + "img/info.004.d96e466d.jpeg";